module.exports = __webpack_public_path__ + "static/media/PN_Newsletter-662-V2.471182ca.jpg";